import { render, staticRenderFns } from "./fundsTrends.vue?vue&type=template&id=7cc42644"
import script from "./fundsTrends.vue?vue&type=script&lang=js"
export * from "./fundsTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports